<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'TournamentMain'
}
</script>

<style></style>
